import React from "react";

const CommonJsonContext = React.createContext();

export default CommonJsonContext;
